import { render, staticRenderFns } from "./ProducersList.vue?vue&type=template&id=138b28ce&scoped=true&"
import script from "./ProducersList.vue?vue&type=script&lang=js&"
export * from "./ProducersList.vue?vue&type=script&lang=js&"
import style0 from "./ProducersList.vue?vue&type=style&index=0&id=138b28ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138b28ce",
  null
  
)

export default component.exports